export default __webpack_public_path__ + "static/articles-lutein-restartirat-1fec1d7c7fe25815d75e7c73351ada92.jpg";